import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useSession } from '@lingaai/shared-hooks';
import { useCurrentUser, useAuthStore } from '@lingaai/user-management';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { data: session, isLoading: sessionLoading } = useSession();
  const { data: user, isLoading: userLoading } = useCurrentUser();

  useEffect(() => {
    if (session?.user && !user && !userLoading) {
      useAuthStore.getState().initialize();
    }
  }, [session, user, userLoading]);

  // Show loading while checking session or loading user
  if (sessionLoading || userLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // No session - redirect to login
  if (!session) {
    return <Navigate to="/login" replace />;
  }

  // Session exists but no user data yet - still loading
  if (!user) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return <>{children}</>;
}
